<template>
	<DjCardJob
		v-if="Object.keys(job).length > 0"
		:job="job"
		:langs="langs"
		:locale="locale"
		:isSaved="isAuth && !updatingJob && useAuth.isSavedJob(job.id)"
		@on-similar-click="similarJobs(job)"
		@on-click="navigateToJobProfile(job)"
		@toggle-saved="toggleSavedJob()"
	/>
</template>
<script lang="ts">
import { defineComponent, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { getJobSlug } from "~~/composables/useJob";

export default defineComponent({
	name: "CardJob",
	props: {
		job: {
			type: Object,
			default: () => {
				return {};
			},
		},
		dataUrl: {
			type: String,
			default: "jobs", // Default API
		},
		newTab: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const router = useRouter();
		const isAuth = useState("isAuth");
		const { locale } = useI18n();
		const langs = useLangs.job;
		const updatingJob = ref(false);
		const gtm = useGTM();

		watchEffect(() => {
			if (globalConfig.isBlue && props.job?.tags?.job_level?.slug && props.job?.tags?.job_level?.name) {
				if ("junior" == props.job.tags.job_level.slug) props.job.tags.job_level.name.hu = "1-3 év tapasztalat ";
				if ("medior" == props.job.tags.job_level.slug) props.job.tags.job_level.name.hu = "3-5 év tapasztalat ";
				if ("senior" == props.job.tags.job_level.slug) props.job.tags.job_level.name.hu = "5+ év tapasztalat ";
			}
		});

		function similarJobs(job) {
			const query = {
				category: job.tags.job_category.id,
				location: job.tags.office_location.data[0].id,
				type: job.tags.job_type.data[0].id,
				level: job.tags.job_level.id,
			};
			// Check that this is the salary carousel
			if (props.dataUrl.includes("hasVisibleSalary")) Object.assign(query, { salary: true });
			router.push({
				path: `/${locale.value}/jobs`,
				query,
			});
		}

		function navigateToJobProfile(job: object) {
			let companySlug = job.company_id ? job.company.slug : "_hidden-company_";
			let jobSlug = getJobSlug(job, locale.value);

			if (props.newTab) {
				window.open(`/${locale.value}/job/${companySlug}/${jobSlug}`, "_blank");
			} else {
				router.push({
					path: `/${locale.value}/job/${companySlug}/${jobSlug}`,
				});
			}
		}
		function toggleSavedJob() {
			if (isAuth.value) {
				$fetch(`/api/save-job`, {
					method: "POST",
					body: {
						companySlug: String(props.job.company.slug),
						jobSlug: getJobSlug(props.job, locale.value),
						xsrf: useAuth.getXsrfToken(),
						token: useCookie("token").value,
						locale: locale.value,
						operation:
							useAuth.isSavedJob(props.job.id) == true
								? "remove-saved-job-from-user"
								: "save-job-to-user", // Save or Unsave
					},
				})
					.then(() => {
						updatingJob.value = true;
						useAuth.refreshSavedJobIds().then(() => {
							updatingJob.value = false;
						});
					})
					.catch((error) => {
						console.error("Job toggleSavedJob", error);
					});

				// GTM tracking
				gtm.trackEvent({
					event: useAuth.isSavedJob(props.job.id) == true ? "b2c-job-unsave" : "b2c-job-save",
				});
			} else {
				router.push(`/${locale.value}/login`);
			}
		}

		return {
			langs,
			locale,
			isAuth,
			similarJobs,
			navigateToJobProfile,
			toggleSavedJob,
			updatingJob,
		};
	},
});
</script>
